<template>
	<section>
		<!--Toolbar -->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" @submit.prevent.native="startSearch">        
				<el-form-item>
					<el-input v-model="searchFilter" placeholder="Search" @change='startSearch'></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon='el-icon-search' size='small' v-on:click="startSearch">{{lang.butSearch}}</el-button>
					<el-button type="" size='small' v-on:click="searchFilter='';getRecords();">C</el-button>
				</el-form-item>
        
				<span style='float:right'>
  				<el-form-item>
	  				<el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">{{lang.butAdd}}</el-button>
		  		</el-form-item>
				</span>
			</el-form>
		</el-col>

		<!--Lijst-->
		<el-table :data="content" stripe highlight-current-row v-loading="listLoading" style="width: 100%;">
 		  <el-table-column prop="usercode" label="UserCode" min-width="150" sortable>
				<template slot-scope="scope">
			    <img :src='"./static/" + scope.row.useravatar' class='icoon' /> <div style='margin:7px 40px'>{{scope.row.usercode}}</div>
        </template>
      </el-table-column>
			<el-table-column prop="username" label="Name" min-width="200" sortable>
			</el-table-column>
			<el-table-column prop="useremail" label="Email" min-width="200" sortable>
			</el-table-column>
			<el-table-column prop="userroles" label="Role(s)" min-width="150" ></el-table-column>
			<el-table-column prop="departments" label="Depts" min-width="150" ></el-table-column>
			<el-table-column prop="stages" label="Stages" min-width="150" ></el-table-column>

			<el-table-column label="" width="100" fixed='right'>
				<template slot-scope="scope" vxif="scope.row._amode == 'M'">  <!------ NNEEEDS WORK!!!!======>
          <div style='float:right' >
          <!--
					<el-button v-if="scope.row.usertoken!=''" type='warning' size="small" xicon="el-icon-edit"  @click="openApps(scope.row)">A</el-button>
          -->
					<el-button type='success' size="small" icon="el-icon-edit"  @click="handleEdit(scope.row)"></el-button>
					<el-button type="danger" size="small" icon="el-icon-delete"  @click="handleDel(scope.row)"></el-button>
          </div>
				</template>
			</el-table-column>
		</el-table>

		<!-- Toolbar -->
		
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev,pager,next,jumper,sizes" @current-change="selectPage" :total="mainTotal" style="float:right;"
                     :current-page='currentPage' :page-sizes="[10, 15, 25, 50, 100, 1000]" @size-change="selectPagesize" :page-size="pageSize"></el-pagination>
      <span style='font-size:80%;margin:9px;float:right'>{{mainTotal}} records found</span>
			</el-col>
    
		<!--Wijzig record -->
		<el-dialog :title="editTitle" :visible.sync="editFormVisible" 
               :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="editForm" label-width="150px" :rules="editFormRules" ref="editForm" >
        <el-tabs type="card">
          <!-- -------------------------------------------------------------------------------------- -->
				  <el-tab-pane>
            <span slot='label'><i class='el-icon-date'></i> User</span>
    	  <el-form-item label="UserCode:" prop="usercode">
					<el-input :disabled="this.editMode=='save'" v-model="editForm['usercode']" auto-complete="off"></el-input>
				</el-form-item>
        <el-form-item label="User Role(s) :" prop="uroles">
          <el-select v-model="uroles" multiple placeholder="Select User Role(s)" style='width:100%'>
            <el-option v-for="item in codes.roles" :key="item.value" :label="item.value"  :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="Department(s) :" prop="udepts">
          <el-select v-model="udepts" multiple placeholder="Select Department(s)" style='width:100%'>
            <el-option v-for="item in codes.depts" :key="item.value" :label="item.value"  :value="item.code"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Allowed Stage(s) :" prop="ustages">
          <el-select v-model="ustages" multiple placeholder="Select Allowed Stages" style='width:100%'>
            <el-option v-for="item in stageList" :key="item" :label="item"  :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Name :" prop="username">
					<el-input v-model="editForm['username']" auto-complete="off"></el-input>
				</el-form-item>
        <el-form-item label="Email :" prop="useremail">
					<el-input v-model="editForm['useremail']" auto-complete="off"></el-input>
				</el-form-item>
        <el-form-item label="New Password:" >
					<el-input v-model="editForm['password']" auto-complete="off"></el-input>
				</el-form-item>
        
        <!-- <el-form-item label="Level :" prop="userlevel">
            <span style='float:left;'>
            <el-select  clearable autocomplete filterable style='width:235px'  
                    v-model="editForm['userlevel']" placeholder='Select User Role' >
            <el-option v-for="item in codes.Level" 
						           :key='item.Code' 
					             :label="item.Value + ' (' + item.Code + ')'" 
						  				 :value='item.Code'></el-option>
  				  </el-select>
            </span>
            <! --
            <span :title="editForm['_udet']" style='margin-top:5px;line-height:14px;font-size:10px;float:right'>
              Hash: {{editForm['pwdhash']}} <br>
              Pwd Modified: {{editForm['pwdmodified']}}
            </span>
            -- >
				</el-form-item>
        -->
        <el-form-item label="Avatar :">
          <img :src='curIcon' class='icoon' />
					  <el-select clearable autocomplete filterable style='width:200px' v-model="editForm.useravatar" value-key='editForm.userImg'
                     placeholder='Select Icon' @change='showChanged'>
						<el-option style='height:45px' v-for="item in codes.Img" :key="item.code" :label="item.desc" :value="item.value">
              <img class='icoon' :src="'./static/' + item.value"><span style='margin:5px 10px;float:left'>{{item.desc}}</span>
            </el-option>
  				</el-select>
          <span :title="editForm['_udet']" style='margin-top:5px;line-height:14px;font-size:10px;float:right'>
            Hash: {{editForm['pwdhash']}}<br>
            Pwd Modified: {{editForm['pwdmodified']}}
          </span>
				</el-form-item>

        <el-form-item label="UserToken :" prop="usertoken">
				  <el-input disabled v-model="editForm['usertoken']" width='10' auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item>
            <span v-if="editForm['usertokenDel']!=true">
            <el-switch :width='40' v-model="editForm['usertokenGen']" xactive-color='green' active-color="#58a632" inactive-color="#ccc"></el-switch>       Generate  &nbsp; &nbsp; &nbsp; 
            </span>
            <span v-if="editForm['usertoken']!='' && editForm['usertokenGen']!=true">
            <el-switch :width='40' v-model="editForm['usertokenDel']" active-color='red' xactive-color="#58a632" inactive-color="#ccc"></el-switch>          Clear
            </span>
          </el-col> 
          <span style='float:right'>
          Reset PWD: &nbsp;&nbsp;
          <el-switch v-model="editForm['pwdreset']" active-color="#409EFF" inactive-color="#ccc"></el-switch>              
          </span>
				</el-form-item>
       

				</el-tab-pane>
				</el-tabs>
			</el-form>

			<div slot="footer" class="dialog-footer">		  
				<el-button size='small' icon="el-icon-upload2"  @click.native="editFormVisible = false">{{lang.butCancel}}</el-button>
				<el-button size='small' type="primary" icon="el-icon-edit"  @click.native="editSubmit" :loading="editLoading">{{lang.butSave}}</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
  import settings from '../../common/AppSettings';
 	import util     from '../../common/AppUtil';
  import text     from '../../common/AppText';
  import api      from '../../api/system/xuser';

	export default {
		data() {
			return {
        QID         : util.Initialize(this.$router,"XU"),
        stageList   : ["PRD","DEV","ITG","QUA"],
        util        : util,
			  stack       : {},
        lang        : text.data,
        codes       : util.codes,
				pageSize    : settings.pageSize,
   			serverPaging: false,

        uroles      : [],
        udepts      : [],
        ustages     : [],
        APICode     : "XUser",
				editTitle   : "",
				editMode    : "",
				mainFunc    : "Users",
				mainSubject : "User",
        mainKey     : "usercode",
				mainKeyDesc : "username",
        searchFilter: '',				

        curIcon     : '',
        content: [],
        contentSaved: [],
				counter: {},
        parent:  [],
				related: [],
				currentPage: 1,
				mainTotal: 0,
		

    werk: "",
				listLoading: false,
				editFormVisible: false,// Of de bewerkingsinterface wordt weergegeven
				editLoading: false,
				editForm: {},			
				editFormRules: {
					usercode: [
						{ required: true, message: text.data.mandatory, trigger: 'blur' }
					],
					username: [
						{ required: true, message: text.data.mandatory, trigger: 'blur' }
					],
					useremail: [
						{ required: true, message: text.data.mandatory, trigger: 'blur' }
					],
					userlevel: [
						{ required: true, message: text.data.mandatory, trigger: 'blur' }
					]
				},

			}
		},
		
		methods: {

      startSearch: function() {
        this.currentPage = 1;
        this.content = [];        
        this.getRecords();
      },
    // paginering wissel, reload page			
		  selectPagesize: function(size) {
				settings.pageSize = size;
				this.showPagedData();
			},
			selectPage: function(page) {
				this.currentPage = page;								
				this.showPagedData();
			},
			showPagedData: function() {
				if (this.serverPaging) this.getRecords();
				else this.content = this.contentSaved.slice((this.currentPage - 1) * 
				                    settings.pageSize,this.currentPage * settings.pageSize);
      },

      // Simple alternative to additional fields. One field (rtoptions) contains all 'flags'...
      /*
      GetEntry: function(rtoptions,entry) {
         if (rtoptions == undefined) return "RT Empty";
         var split = rtoptions.split('|');
         if (split.length >= entry)
           return split[entry];
         return "E-" + entry + " Unknown";
      },
      */
			// Ophalen record(s) via API
			getRecords() {
        //var parg = util.cloneParam(this.stack); 

        let parg = {};
        parg.Params = {};
        parg.Params["search"] = this.searchFilter;

        
        if (this.serverPaging)
				{
				  parg.Params["_page"] = this.currentPage;      /* FOR SERVER-SIDE PAGING! */
				  parg.Params["_psize"] = settings.pageSize;    /* UNCOMMENT THIS!!        */
        }	
		
				this.listLoading = true;
       				
				api.getListPage(parg).then((res) => {						
          util.processMainResults(res);
          this.codes = util.codes;
          this.mainTotal = util.payload[this.APICode].length;         
          if (this.mainTotal > 0)
          {
            if (this.serverPaging)
           	  this.content = util.getMainPayload(this.APICode);
			  		else {
 				  		this.contentSaved = util.getMainPayload(this.APICode);
  				    if (this.contentSaved.length > 0)
    				    this.selectPage(1);
  					}
          }
					else {
            this.content = [];
            this.contentSaved = [];
          }
          this.listLoading = false;
				})
        .catch((error) => {
          util.serverError(this);
        });

        this.listLoading = false;

			},
			
			showChanged: function () {
        if (this.editForm.useravatar)
        {
          this.curIcon = "./static/" + this.editForm.useravatar;
        }
			},

      openApps: function(row) {
        this.stack["user"] = row.usercode;       
        this.$router.push({name: 'User Application Access',params: this.stack});
      },

			openRelated: function(row) {       
			},

			// Verwijder
			handleDel: function (row) {
				this.$confirm(text.getText("sdelM",this.mainSubject,row[this.mainKeyDesc]), 'Confirm', {
					type: 'warning',title: text.getText("sdelT",this.mainSubject)
				}).then(() => {
					this.listLoading = true;

          let parg = {};
          parg.Record = row;
 
				  api.removeRecord(parg).then((res) => {
            util.processMainResults(res);
						this.listLoading = false;
  					this.$notify({
	  				  title: text.data.conf,type: 'success',
		  				message: text.getText("delOK",this.mainSubject,row[this.mainKeyDesc])			  			 
				  	});
            this.startSearch();
					});

				}).catch(() => {

				});
			},
			
			// Display bewerkingsinterface
			handleEdit: function (row) {
        this.editMode = "save";
				this.editTitle = text.getText("modM",this.mainSubject,row[this.mainKeyDesc]);
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
        this.uroles = [];
        this.udepts = [];
        this.ustages = [];
        if (this.editForm['userroles'] != "")
          this.uroles = this.editForm["userroles"].split(' ');
        if (this.editForm['departments'] != "")
          this.udepts = this.editForm["departments"].split(' ');
        if (this.editForm["stages"])
          this.ustages = this.editForm["stages"].split(' ');
        {
        }
        //this.editForm['usertokenDel'] = false;
        //this.editForm['usertokenGen'] = false;
        this.showChanged();
      },
			
			
			// Toon nieuwe interface
			handleAdd: function () {
				this.editMode = "add";
				this.editTitle = text.getText("addM",this.mainSubject);
				this.editFormVisible = true;
				this.editForm = {};
        this.uroles = ["user"];
        this.udepts = [];

			},

			// uitgeven
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
					  this.editLoading = true;
						   
						/*
            let parg = Object.assign({}, this.editForm);
            if (parg["password"] != undefined)
                parg["rtoptions"] = "$PWD|" + parg["password"];
            if (this.editForm['usertokenDel']) parg["rtoptions"] += "|$DTK";
            if (this.editForm['usertokenGen']) parg["rtoptions"] += "|$GTK";
             
            */
            let parg = {};
            parg.Params = {};
            parg.Record = this.editForm;
            parg.Record["userroles"] = this.uroles.join(' ');
            parg.Record["departments"] = this.udepts.join(' ');
            parg.Record["stages"] = this.ustages.join(' ');

            if (this.editMode == "add") 
            {
							api.addRecord(parg).then((res) => {
                util.processMainResults(res);
                if (util.header.OK)
                  this.$notify({title: text.data.done, type: 'success',
								                message: text.getText("addOK",this.mainSubject,this.editForm.usercode)});
                else this.$notify({title: "Error",type: 'error',message: util.header.message});
		    				this.$refs['editForm'].resetFields();
        				this.editLoading = false;  
	  		    		this.editFormVisible = false;
   			 	  		this.getRecords();
	  					});
            }
						else {
							api.saveRecord(parg).then((res) => {		  					
                util.processMainResults(res);
                if (util.header.OK)
                  this.$notify({title: text.data.done, type: 'success',
								                message: text.getText("modOK",this.mainSubject,this.editForm.usercode)});
                else this.$notify({title: "Error",type: 'error',message: util.header.message});
						    this.$refs['editForm'].resetFields();
        				this.editLoading = false;  
	  		    		this.editFormVisible = false;
		    				this.getRecords();
	  					});
            }
					}
				});
			},
		},

		mounted() {
			//this.related = settings.getRelated();
      if (this.$route.params)
        this.stack = this.$route.params;

			this.getRecords();
		}
	}

</script>

<style scoped>
 .icoon {height:30px;width:30px; float:left;margin-right:5px;}
</style>


// WEBPACK FOOTER //
// xuser.vue?56a8c737